import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import { fetchMe } from './session.ts';

interface SessionState {
  phone: string | null;
  subscribed: boolean;
  loading: boolean;
  refresh: () => Promise<void>;
}

const SessionCtx = createContext<SessionState>({
  phone: null,
  subscribed: false,
  loading: true,
  refresh: async () => {},
});

export function SessionProvider({ children }: { children: ReactNode }) {
  const [phone, setPhone] = useState<string | null>(null);
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const me = await fetchMe();
      setPhone(me.phone);
      setSubscribed(me.subscribed);
    } catch {
      setPhone(null);
      setSubscribed(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return (
    <SessionCtx.Provider value={{ phone, subscribed, loading, refresh }}>
      {children}
    </SessionCtx.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSession(): SessionState {
  return useContext(SessionCtx);
}
